import {Col, Row} from "antd";
import styled from "styled-components";

export const Container = styled(Row)`
    width: 100%;
    height: max(calc(100vh - 120px), 500px);
    justify-content: center;

    @media screen and (max-width: 992px) {
        flex-direction: row-reverse;
    }
`;

export const FormContainer = styled(Col)`
    height: 100%;
    overflow: auto;
    @media screen and (max-width: 992px) {
        height: 80%;
    }
`;
export const MapContainer = styled(Col)`
    border: 5px solid #b2fc35;
    height: 100%;
    @media screen and (max-width: 992px) {
        height: 20%;
    }
`;
